import React from 'react';
import styled, { withTheme } from 'styled-components'

import { Box } from 'vqp-common'
import { Icon } from '../common'
import { CardTitle } from './'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Card = styled(Box)`
    display: flex;
    flex-direction: column;
    height: 278px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const IconScoreWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 30px;
`

const RatingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 10px;
`

const Score = styled.span`
    font-size: 55px;
    font-weight: bold;
    color: ${props => props.theme.colors.secondary}
`

const TotalRatings = styled.span`
    font-size: 12px;
    font-style: italic;
    margin-top: -10px;
    color: ${props => props.theme.colors.textPrimary}
`

export const RatingScoreCard = withTheme( ({score, totalRatings, theme}) => (
    <Wrapper>
        <CardTitle>Avaliações</CardTitle>
        <Card>
            <Icon name={"medal"} stroke={theme.colors.secondary} fill={theme.colors.secondary} />
            <IconScoreWrapper>
                <Icon name={"starBig"} />
                <RatingWrapper>
                    <Score>{Number(score).toFixed(1)}</Score>
                    <TotalRatings>({totalRatings} avaliações)</TotalRatings>
                </RatingWrapper>
            </IconScoreWrapper>
        </Card>
    </Wrapper>
))

